import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import type { State } from './types.tsx';
import { SIDEBAR_MIN_WIDTH, SIDEBAR_MIN_WIDTH_OLD } from './constants.tsx';

export const localStorage = createLocalStorageProvider('jira_business_common');

export const getSidebarWidthFromStore = (store: State) => {
	if (store.sidebarWidth) {
		return store.sidebarWidth;
	}

	return isVisualRefreshEnabled() ? SIDEBAR_MIN_WIDTH : SIDEBAR_MIN_WIDTH_OLD;
};
